import { css } from '@emotion/react'
import * as React from 'react'
import BodyClassName from 'react-body-classname'
import Helmet from '../misc/PageHelmet'
import { Link } from 'react-router-dom'
import { closestEventsPath } from '../../../startup/routes'

// Shown in place of an event page when the address matches no event the visitor may see.
const EventNotFound: React.FC = () => (
  <BodyClassName className="path-events">
    <section className="two-col event-view">
      <Helmet>
        <title>Event not found</title>
      </Helmet>
      <div className="event-main">
        <Link
          to={location => closestEventsPath(location.pathname)}
          css={css`
            display: inline-flex;
            align-items: center;
            gap: 6px;
            height: 25px;
            border-bottom: 1px solid #aaa;

            margin-top: 20px;
            @media (min-width: 768px) {
              margin-top: 0;
              margin-bottom: 10px;
            }
          `}
        >
          <span style={{ fontFamily: 'Arial, Helvetica, sans-serif' }}>←</span>
          <span>Back to Calendar</span>
        </Link>

        <article className="single-event-content">
          <h1 className="single-event-title">We couldn&apos;t find that event</h1>
          <p>It may have been removed, or the address may be mistyped.</p>
        </article>
      </div>
    </section>
  </BodyClassName>
)

export default EventNotFound
